import { combineReducers } from 'redux';
import { reducer as reduxAsyncConnect } from 'redux-connect';

import { app } from './app';
import { audioClips } from './audioClips';
import { auth } from './auth';
import { categories } from './browse';
import { config } from './config';
import { desktop } from './desktop';
import { dialog } from './dialog';
import { fakeAuth } from './fakeAuth';
import formReducer from './formReducer';
import { heroCarousel } from './heroCarousel';
import { loginDetails } from './loginDetails';
import { me } from './me';
import { metrics } from './metrics';
import { messagePopover } from './messagePopover';
import { mint } from './mint';
import { paymentCompletion } from './paymentCompletion';
import { partners } from './partners';
import { player } from './player';
import { preroll } from './preroll';
import { products } from './products';
import { profiles } from './profile';
import { search } from './search';
import { subscription } from './subscription';
import { subscriptionFlow } from './subscriptionFlow';
import { unlockDetails } from './unlockDetails';
import { users } from './users';

export default combineReducers({
  reduxAsyncConnect,

  // custom reducers
  app,
  audioClips,
  auth,
  categories,
  config,
  desktop,
  dialog,
  fakeAuth,
  form: formReducer,
  heroCarousel,
  loginDetails,
  me,
  messagePopover,
  metrics,
  mint,
  paymentCompletion,
  partners,
  player,
  preroll,
  products,
  profiles,
  search,
  subscription,
  subscriptionFlow,
  users,
  unlockDetails,
});
